import {CFValue} from 'module/CustomField/type/CFType'

export function isElementCFDefInputWith(el: Element | HTMLElement | null, focusPosition: { cfDefId: number; pos?: number }): boolean {
	if (!el) return false
	const cfdefid = el.getAttribute('data-cfdefid')
	const pos = el.getAttribute('data-cfdefpos')
	if (cfdefid) {
		if (
			Number(cfdefid) === focusPosition.cfDefId &&
			(focusPosition.pos === undefined || Number(pos) === focusPosition.pos)
		) {
			return true
		} else {
			return false
		}
	}
	return isElementCFDefInputWith(el.parentElement, focusPosition)
}

export function findNearestCFDefIDPosTuple(el: Element | HTMLElement | null): { cfDefId: number, pos?: number } | undefined {
	if (!el) return undefined
	if (typeof el.getAttribute === 'function') {
		const cfDefId = el.getAttribute('data-cfdefid')
		const pos = el.getAttribute('data-cfdefpos')
		if (cfDefId) return {
			cfDefId: parseInt(cfDefId),
			pos: pos ? parseInt(pos) : undefined,
		}
	}
	return findNearestCFDefIDPosTuple(el.parentElement)
}

/**
 * Convert a number or string to a float.
 * @param value Number or string.
 * @param precision Float precision.
 * @returns Float.
 */
export function toFloat(value: CFValue, precision?: number | string) {
	if (!value) return 0.0;
	let val = parseFloat(value + '');
	if (!precision) return val;
	const p = Math.pow(10, +precision);
	return (Math.round(val * p) / p).toFixed(+precision);
}